import React from "react";
import Modal from "react-bootstrap/Modal";

const GrnTrackingModal = ({ isOpen, toggle, data, totalPoQty }) => {
  return (
    <Modal show={isOpen} size="xl" onHide={toggle} backdrop="static">
      <Modal.Header closeButton className="Creative-Invoice-header-styling p-3">
        <Modal.Title>GRN Tracking</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ overflowX: "auto" }}>
        <table className="table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th colSpan="5">Purchase Order</th>
              <th colSpan="3">GRN Detail</th>
            </tr>
            <tr>
              <th>Code</th>
              
              <th>
                {data && data.length > 0 && data[0].Item_Name 
                  ? "Item Name" 
                  : "Expense Name"}
              </th>

              <th>Total PO Qty</th>
              <th>Total GRN Qty</th>
              <th>Balance</th>
              <th>GRN Date</th>
              <th>GRN No</th>
              <th>GRN Qty</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const rowSpanCount = item.grns.length > 0 ? item.grns.length : 1;
              const balance = item.PO_Qty - item.total_GRN;

              return (
                <React.Fragment key={index}>
                  <tr>
                    <td rowSpan={rowSpanCount}>{item.Code}</td>
                    
                    <td rowSpan={rowSpanCount}>
                      {item.Item_Name ? item.Item_Name : item.Expense_Name}
                    </td>
                    
                    <td rowSpan={rowSpanCount}>{item.PO_Qty}</td>
                    <td rowSpan={rowSpanCount}>{item.total_GRN}</td>
                    <td rowSpan={rowSpanCount}>{balance}</td>

                    {item.grns.length > 0 ? (
                      <>
                        <td>{item.grns[0].GRN_Date}</td>
                        <td>{item.grns[0].GRN_No}</td>
                        <td>{item.grns[0].GRN_Qty}</td>
                      </>
                    ) : (
                      <>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </>
                    )}
                  </tr>

                  {item.grns.slice(1).map((grn, grnIndex) => (
                    <tr key={`${index}-${grnIndex}`}>
                      <td>{grn.GRN_Date}</td>
                      <td>{grn.GRN_No}</td>
                      <td>{grn.GRN_Qty}</td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })}

            <tr style={{ fontWeight: "bold" }}>
              <td colSpan="2" className="text-right">
                Total:
              </td>
              <td>{totalPoQty}</td>
              <td>
                {data.reduce((sum, item) => sum + item.total_GRN, 0)}
              </td>
              <td>
                {data.reduce(
                  (sum, item) => sum + (item.PO_Qty - item.total_GRN),
                  0
                )}
              </td>
              <td colSpan="3"></td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
};

export default GrnTrackingModal;